import { hr } from "./hr";

export const en: { [key in keyof typeof hr]: string } = {
  ...hr,
  travelWarrantDeparturePeriod: "Period by departure date (inclusive)",
  travelWarrantAllDates: "All dates",
  travelWarrantAccountBalance: "Account balance",
  travelWarrantAccountBalancePeriodNote: "Balance from accounting records, independent of the selected departure period.",
  "external-accounts": "Connected accounts",
  "mcp-api-keys": "MCP API keys",
  showAdDate: "Show document date entry",
  isBackgroundInstallable: "Background install",
  minPantheonBuildNo: "Min Pantheon build",
  maxPantheonBuildNo: "Max Pantheon build",
  pantheonBuildConstraintsInfoTitle: "Pantheon build constraints",
  pantheonBuildConstraintsInfo:
    "Uses the last 4 digits of the build number (e.g. 4600). Leave empty to always offer the group.",
  marservis_workorders_ending_soon:
    "Radni nalozi koji završavaju unutar 5 dana",
  itemName: "Artikl",
  projectName: "Projekt",
  subjectName: "Subjekt",
  documentNumber: "Broj dokumenta",
  workDate: "Datum rada",
  work_orders_overview: "Pregled",
  Warehouse: "Skladište",
  List: "Pregled dokumenata",
  UnfinishedDocuments: "Nedovršeni dokumenti",
  FIXED_ASSETS: "Osnovna sredstva",
  MARSERVIS_USER_WORK_ORDERS: "Radni nalozi",
  "work-attachments": "Prilozi poslova",
  "writing-response-internal-communication": "Nova interna poruka",
  "add-internal-communication": "Dodaj internu poruku",
  "users-with-access": "Kontrola pristupa",
  forBilling: "Za naplatu",
  "work-hours": "Sati rada",
  FixedAssets: "Osnovna sredstva",
  skipConfirmationOnShortcuts:
    "Skoči direktno na izradu krajnjeg dokumenta (umjesto prikaza detalja izvornog dokumenta)",
  showModifierCharacterPicker: "Show modifier character picker",
  modifierCharacterLabel: "Modifier character label",
  showModifierCharacterPickerElementDescription:
    "Show a modifier filter picker before source document items are loaded",
  modifierCharacterLabelElementDescription:
    "Label shown in the modifier filter picker",
  defaultSubjectPaymentMethodOnAdd:
    "Default payment method when adding a subject",
  defaultSubjectPaymentMethodOnAddElementDescription:
    "When adding a subject, use this payment method by default. Leave empty to keep the current default behavior.",
  pickingShowConfirmationOnPick:
    "Prikaži poruku da je dostignuta potrebna količina",
  healthchecks_dashboard: "Healthchecks",
  transformation: "Transformacija",
  fromId: "Od",
  toId: "Na",
  sql_views: "Views",
  sql_triggers: "Triggers",
  sql_other_objects: "Other objects",
  sql_synonyms: "Synonyms",
  sql_sequences: "Sequences",
  sql_types: "Types",
  sql_schemas: "Schemas",
  sql_roles: "Roles",
  sql_columns: "Columns",
  sql_constraints: "Constraints",
  sql_indexes: "Indexes",
  sql_parameters: "Parameters",
  sql_dependencies: "Dependencies",
  sql_memberships: "Memberships",
  sql_permissions: "Permissions",
  sql_object: "Object",
  sql_parent: "Parent",
  sql_object_type: "Type",
  sql_details: "Details",
  sql_disabled: "Disabled",
  sql_object_details_loading: "Loading object details...",
  sql_object_details_empty: "No details are available for the selected object.",
  sql_object_details_load_failed: "Object details could not be loaded",
  view_name: "View",
  WorkOrdersReception: "Radni nalozi - prijem",
  WorkOrdersOperative: "Radni nalozi - operativa",
  Orders: "Narudžbe",
  Approvals: "Odobrenje",
  DeliveryNotesControl: "Kontrola otpremnice",
  DeliveryNotesFromOrder: "Otpremnica iz narudžbe",
  InvoiceDeliveryNotes: "Račun iz otpremnice",
  LURInvoice: "Račun - Lučka uprava rovinj",
  MarservisUserWorkOrders: "Korisnički radni nalozi - Marservis",
  DeliveryNotes: "Otpremnice",
  acWorkPlace: "Radno mj.",
  acFiscalDevice: "Fiskalni ur.",
  Copy: "Kopiranje",
  wiki_local: "Local wiki",
  wiki: "Wiki",
  "delete-support-todo": "obrisati ovaj podsjetnik?",
  "no-team-viewer-sessions": "Nema TeamViewer sesija",
  "total-time-on-teamviewer": "Ukupno vrijeme TeamViewer",
  "delete-support-time-log": "obrisati ovo vrijeme rada?",
  todos: "Podsjetnici",
  duration: "Trajanje",
  startDate: "Početak",
  endDate: "Kraj",
  userId: "User",
  deviceName: "Naziv uređaja",
  deviceId: "ID uređaja",
  supportTicketTimeLogId: "Vrijeme rada",
  supportTicketId: "Tiket",
  update: "Ažuriraj",
  "want-to-close-without-billable-time-log-or-unassigned-team-viewer-sessions":
    "nastaviti bez naplativog vremena rada ili s TeamViewer sesijama koje nemaju povezano vrijeme rada?",
  "want-to-close-with-unassigned-team-viewer-sessions":
    "Želite li nastaviti s TeamViewer sesijama koje nemaju vrijeme rada?",
  "editing-team-viewer-session": "Editing TeamViewer session",
  "adding-new-team-viewer-session": "Adding TeamViewer session",
  team_viewer_sessions: "TeamViewer",
  "expense-bearer-changed-since-adding-to-this-document":
    "Job number changed, click here to recalculate per diems and currency rates.",
  adminUseAnWsPrice: "Koristi AnWsPrice prije ostalih",
  adminShowDailyIncome: "Prikaži zaključak blagajne",
  articleSearchShowOnlyWhereAcFieldsAIs:
    "Prikaži artikle tamo gdje je AcFieldsA",
  articleSearchAllowSearchingByClassification:
    "Prikaži filter po klasifikaciji prije liste idenata",
  adminUseGenericDocumentsForMoveAndOrder:
    "Koristi generičku izradu dokumenata za THeMove i THeOrder",
  adminSendDocumentToCompanyDocumentEmail:
    "Šalji sažetak dokumenta na Email poduzeća",
  adminIgnoreRebate1: "Ne koristi rabat 1",
  adminIgnoreRebate2: "Ne koristi rabat 2",
  adminIgnoreRebate3: "Ne koristi rabat 3",
  "department-items": "Department items",
  workOrder: "Work order",
  "automatic-logout": "Automatic logout",
  system: "System",
  "general-settings": "General settings",
  workOrderStatus: "Work order status",
  "mark-as-not-finished": "Mark as not finished",
  WorkOrderInitials: "WO",
  itemGroup: "Group",
  "Ne postoji ova veza artikla i grupe":
    "This article and group are not connected",
  workOrderDate: "Datum radnog naloga",
  totalWorkTime: "Ukupno vrijeme rada",
  "item-groups": "Article groups",
  "add-to-customer": "Add to customer",
  "connect-project": "Connect project",
  "The DateEnd field is required.": "Pick an end date",
  "The ProjectId field is required.": "Pick a project",
  transmissionSerialNumber: "Transmission serial number",
  engineSerialNumber: "Engine serial number",
  hinNumber: "HIN number",
  "mark-as-finished": "Mark as finished",
  InProgress: "In progress",
  "total-hours": "Total hours",
  "department-overview": "Department",
  "connect-item": "Connect item",
  "add-to-group": "Add to group",
  "item-group-overview": "Group",
  billableTime: "Billable hours",
  "work-order-open": "Work order open",
  workOrderId: "Work order ID",
  itemGroupName: "Group",
  "new-entry": "New entry",
  "without-group": "Without group",
  "picking-article-group": "Pick an article group",
  "add-all-items-from-group": "Add articles from group",
  hasAccess: "Pristup",
  "adding-user-to-file-permissions": "Add new user",
  "you-want-to-delete-this-file": "delete this file?",
  permissions: "Permissions",
  "date-changed-do-you-want-to-recalculate-down-payment-conversion":
    "Do you want to recalculate the down payment conversion rate to use selected date?",
  experiments: "Eksperimenti",
  "download-pdf": "Download PDF",
  "open-pdf": "Open PDF",
  creating: "Creating",
  updating: "Updating",
  reading: "Deleting",
  deactivated: "Deactivated",
  "A task must have responsible agent": "A task must have responsible agent",
  "task-end-date": "End date",
  deleting: "Deleting",
  uploading: "Uploading",
  saving: "Saving",
  "there-was-an-error": "There was an error",
  "try-again": "Please try again",
  "drop-files-for-upload": "Drop files for upload",
  "drop-some-files-or-click-to-select":
    "Drag some files here or click to select them",
  "adding-file": "Adding attachment",
  "editing-file": "Editing attachment",
  "document-details": "Document details",
  "delete-document": "this document?",
  itemGroupId: "Article group",
  departmentId: "Article department",
  Hangfire: "Hangfire",
  Swagger: "Swagger",
  GraphQL: "GraphQL",
  department: "Department",
  "item-group": "Item group",
  "editing-item-group": "Editing item group",
  "adding-item-group": "Adding item group",
  "adding-department": "Adding a department",
  "editing-department": "Editing a department",
  "server-downtimes": "Server downtime",
  "do-you-want-to-apply-new-conversion-for-currency":
    "Do you want to update the currency conversion? From {conversionFrom} {currency} to {conversionTo} {currency}",
  "codebooks-departments": "Departments",
  "codebooks-item-groups": "Article groups",
  item_groups: "Article groups",
  departments: "Departments",
  OpenTasks: "Open tasks",
  "save-and-close": "Save and close",
  "save-and-set-status": 'Save and set "{{status}}"',
  model: "Model",
  engineModel: "Engine",
  transmissionModel: "Transmission",
  "adding-sql-template": "Adding SQL template",
  "editing-sql-template": "Editing SQL template",
  sql_templates: "SQL templates",
  editing_packet: "Editing packet",
  firstName: "Name",
  lastName: "Surname",
  userName: "Username",
  companySettingsId: "Company",
  companySettings: "Company",
  ForReview: "Review",
  "undock-sidebar": "Undock sidebar",
  "dock-sidebar": "Dock sidebar",
  "spam-emails": "Spam emails",
  "adding-spam-email": "Adding spam email",
  "editing-spam-email": "Editing spam email",
  "save-task": "Save task",
  "add-task": "Add task",
  "writing-response-task": "Adding a new task",
  grouping: "Grouping",
  attachments: "Attachments",
  "grouping-settings-notice":
    'Grouping is only applied to currently visible items, to apply grouping to all items, use "Show all items" button.',
  "show-paginated": "Show paginated",
  "show-all-items": "Show all items",
  "rest-of-the-groups": "Other groups",
  "active-groups": "Active groups",
  groups: "Groups",
  pantheonId: "Pantheon ID",
  "grouping-settings": "Grouping settings",
  "toggle-status": "Toggle status",
  Done: "Done",
  NotDone: "Not done",
  temporaryOwner: "Agent",
  Invoiced: "Invoiced",
  expenseBearer: "Job number",
  true: "Yes",
  false: "No",
  all: "All",
  isDone: "Finished",
  applicationUser: "Worker",
  Users: "Users",
  Workers: "Workers",
  Contacts: "Contacts",
  Projects: "Projects",
  CompanySettings: "Databases",
  TicketMessages: "Ticket messages",
  Tickets: "Tickets",
  Companies: "Companies",
  "id-or-pantheonid": "Web or Pantheon ID",
  "money-accounts": "Money accounts",
  "customer-accounts": "Customer accounts",
  "supplier-accounts": "Supplier accounts",
  "add-account": "Adding account",
  "edit-account": "Editing account",
  "are-you-sure-you-want-to-delete": "Are you sure you want to delete '{0}'?",
  "business-analysis-accounts": "Accounts",
  account: "Account",
  "business-analysis-settings": "Business analysis settings",
  "add-money-account": "Adding money account",
  "edit-money-account": "Editing money account",
  pantheon_key: "Pantheon key",
  onix_key: "Onix key",
  synchronized: "Synchronized",
  not_synchronized: "Not synchronized",
  costBearer: "Cost bearer",
  costBearerName: "Cost bearer name",
  day: "Day",
  costType: "Cost type",
  pantheonCostGroup: "Pantheon cost type",
  pantheonCostGroupName: "Pantheon cost type group",
  pantheonCostType: "Pantheon cost type",
  pantheonWorker: "Pantheon worker",
  workHours: "Work hours",
  workMinutes: "Work minutes",
  workRecordCostType: "Cost type",
  workerId: "Worker Id",
  downloads: "Downloads",
  "adding-new-company-document": "Adding new company document",
  "editing-company-document": "Editing company document",
  fileId: "Document",
  customer: "Customer",
  warehouseOverviewShowOnlyInStock: "Prikaži samo dostupno",
  articleSearchShowOnlyInStock: "Prikaži samo dostupno",
  articleSearchInitiallyLoadAll: "Učitaj sve kod otvaranja",
  articleSearchRepeatLastSearch: "Ponovi prethodno pretraživanje",
  itemListShowDetailed: "Prikaži više detalja",
  documentOnCreateMakePdf: "Izradi PDF novog dokumenta",
  documentOnCreateMakeBluetoothPrint:
    "Ispiši novi dokument na Bluetooth printer ",
  stockViewLoadAllOnOpen: "Učitaj sve kod otvaranja",
  stockViewShowOnlyInStock: "Prikaži samo dostupno",
  addingItemWarnIfQuantityMoreThanAvailable:
    "Upozori ako je količina veća od dostupne",
  bluetoothPrintCopiesNumber: "Broj kopija",
  cacheDuration: "Trajanje (min)",
  cacheUseCacheForAnyResource: "Predmemorija za sve resurse",
  cacheUseForArticleSearch: "Za artikle",
  cacheUseForCustomerSearch: "Za kupce",
  cacheUseForWarehouseSearch: "Za skladište",
  adminDocumentOnCreateMakeWarehouseReservation:
    "Izradi rezervaciju na skladištu",
  adminAllowChangingItemPrice: "Dopusti promijenu cijene",
  adminItemQuantityMustBeInStock: "Količina ne smije biti veća od dostupne",
  adminCanEditDocumentAfterSaving: "Omogući uređivanje nakon spremanja",
  adminUseSerialNumberForItems: "Koristi serijske brojeve za stavke",
  adminDeleteItemsAfterDocumentIsSaved:
    "Omogući brisanje stavaka nakon spremanja",
  "bluetooth-printer": "Bluetooth printer",
  document: "Document",
  items: "Articles",
  "adding-items": "Adding articles",
  "codebooks-items": "Articles",
  "adding-item": "Adding article",
  "editing-item": "Editing article",
  materials: "Materials",
  "marservis-user-work-orders": "Work orders",
  jobs: "Jobs",
  "adding-work-order-job": "Adding work order job",
  "editing-work-order-job": "Editing work order job",
  itemId: "Article",

  "admin-settings": "Administrator settings",
  warehouseName: "Warehouse",
  functionality: "Functionality",
  "users-old-and-new-notice":
    "Old users and new users use the same users but user-level settings are different, use old users for Onix Phone < 9.1.1",
  "users-old": "Users old",
  "users-new": "Users new",
  "admin-users-v2": "Users new",
  "want-to-delete-item": "delete this row?",
  "contact-has-no-companies": "Contact has no companies",
  "saved-filters": "Saved filters",
  "apply-filter": "Apply filter",
  "created-on-date": "Created on date",
  "not-selected": "Not set",
  id: "Id",
  "modified-on-date": "Modified on date",
  "due-date": "Due date",
  "Pantheon AcConfrm is not 'T' and AcStatus is not 'Otvoren'":
    "Pantheon AcConfrm is not 'T' and AcStatus is not 'Otvoren'.",
  "there-was-an-error-while-syncing": "There was an error during sync",
  "time-of-return": "Time of return",
  "time-of-departure": "Time of departure",
  "The CostTypeId field is required.": "Pick a cost type",
  "The Currency field is required.": "Pick a currency",
  "The CurrencyId field is required.": "Pick a currency",
  "The Date field is required.": "Pick a date",
  "The ExpenseBearerId field is required.": "Pick a job number",
  "The Value field is required.": "Enter a value",
  "Travel start date time must be before travel end time":
    "Must be before return",
  "Travel start meter must be less than travel end meter":
    "Must be less than ending",
  "Travel warrant is closed": "Travel warrant is closed",
  "add-time-log": "Add time log",
  "added-note": "Added note",
  testing: "Testing",
  "adding-new-personal-vehicle": "Adding new personal vehicle",
  "adding-travel-warrant-item": "Adding expense",
  "close-travel-warrant": "Close travel warrant",
  "contact-companies": "Contact companies",
  "contact-emails": "Contact emails",
  "cost-type": "Cost type",
  "date-of-departure": "Date of departure",
  "date-of-return": "Date of return",
  "document-id": "Document key",
  "edit-other-personal-vehicles": "Edit other personal vehicles",
  "edit-travel-warrant-item": "Edit expense",
  "editing-new-personal-vehicle": "Editing new personal vehicle",
  "editing-travel-warrant-item": "Editing expense",
  "editing-user-filter": "Editing user filter",
  "end-date": "End date",
  "expense-bearer": "Job number",
  "image-picking": "Image picking",
  "meter-state": "Meter state",
  "new-travel-warrant": "New travel warrant",
  "new-travel-warrant-item": "New expense",
  "no-items": "No items",
  "no-items-for-search": "No items for filter",
  "no-saved-user-filters": "No saved user filters",
  "no-time-logs": "No time logs",
  "no-travel-warrant-items-for-travel-warrant": "No items",
  "no-travel-warrants-for-filter": "No travel warrants for filter",
  "official-vehicle": "Official",
  "open-travel-warrant": "Open travel warrant",
  "personal-vehicle": "Personal",
  personal: "Personal",
  official: "Official",
  "personal-vehicles": "Personal vehicles",
  "received-from-contact": "Received from contact",
  "save-header-changes": "Save header changes",
  "saving-user-filter": "Saving user filter",
  "sent-to-contact": "Sent to contact",
  "show-travel-warrant-items": "Show travel warrant items",
  "start-date": "Start date",
  "support-email": "Support email",
  "support-settings": "Support settings",
  "support-tenant-settings": "Support tenant settings",
  "support-auto-reply-on-new-ticket":
    "Send an automatic acknowledgement as soon as a new ticket is created",
  "support-auto-reply-on-new-ticket-subject": "New ticket auto-reply subject",
  "support-auto-reply-on-new-ticket-body": "New ticket auto-reply message",
  "support-auto-reply-placeholders":
    "You can use rich text formatting. Available placeholders: {{ticketNumber}}, {{ticketTitle}}, {{contactName}}, {{supportEmail}}, {{companyName}}",
  "ai-support-settings-tab": "AI support",
  "ai-support-settings-description":
    "Configure the per-company API key, models, and limits for the AI investigator.",
  "ai-support-api-key": "API key",
  "ai-support-api-key-placeholder": "Optional tenant override key",
  "ai-support-api-key-description":
    "Leave empty to keep using the server fallback key for this tenant.",
  "ai-support-api-key-fallback-note":
    "You can store a tenant-specific API key here. If you leave it empty, the server fallback key will be used.",
  "ai-support-settings-starting-point":
    "Good starting point: use a smaller/cheaper triage model, a stronger investigation model, reasoning effort Medium, verbosity Concise, {{maxToolRounds}} tool rounds, {{maxInputTokensPerTurn}} max input tokens, {{maxOutputTokensPerTurn}} max output tokens, and a {{defaultTimeoutMinutes}} minute timeout.",
  "ai-support-models-loading": "Loading available models for this API key...",
  "ai-support-models-loaded":
    "Loaded {{count}} available models. You can pick from the dropdown or type a model ID manually.",
  "ai-support-models-load-failed":
    "Could not load models for this API key: {{error}}",
  "ai-support-models-load-failed-generic":
    "Could not load models for this API key.",
  "ai-support-models-empty":
    "No models were returned for this API key. You can still type a model ID manually.",
  "ai-support-triage-model": "Triage model",
  "ai-support-triage-model-placeholder": "Enter the triage model ID",
  "ai-support-triage-model-description":
    "Use a smaller, cheaper model here because triage does not run the full investigation loop.",
  "ai-support-investigation-model": "Investigation model",
  "ai-support-investigation-model-placeholder":
    "Enter the investigation model ID",
  "ai-support-investigation-model-description":
    "Use a stronger model here because it handles tool calls and final conclusions.",
  "ai-support-reasoning-effort": "Reasoning effort",
  "ai-support-verbosity": "Reasoning summary verbosity",
  "ai-support-run-budget-mode": "Run budget mode",
  "ai-support-run-budget-mode-bounded": "Bounded",
  "ai-support-run-budget-mode-run-until-terminal": "Run until terminal",
  "ai-support-run-budget-mode-bounded-note":
    "Runs always stay bounded. The AI is told to finish in as few runs as possible, and automatic continuation still stops at the thread-level caps.",
  "ai-support-run-budget-mode-run-until-terminal-note":
    "Run until terminal ignores the per-run timeout and step budget. The AI keeps going until it replies, concludes, asks a follow-up question, requests access, or fails.",
  "ai-support-bounded-only-setting-note":
    "This setting is only enforced in Bounded mode.",
  "ai-support-max-tool-rounds": "Max tool rounds",
  "ai-support-max-input-tokens": "Max input tokens per turn",
  "ai-support-max-output-tokens": "Max output tokens per turn",
  "ai-support-timeout-minutes": "Timeout (minutes)",
  "ai-support-reasoning-effort-minimal": "Minimal",
  "ai-support-reasoning-effort-low": "Low",
  "ai-support-reasoning-effort-medium": "Medium",
  "ai-support-reasoning-effort-high": "High",
  "ai-support-reasoning-effort-none": "None",
  "ai-support-verbosity-description": "Controls the reasoning summary, not the length of the final answer.",
  "ai-support-input-budget-description": "Approximate initial context budget. Does not cap the entire conversation history.",
  "ai-support-output-budget-description": "Includes reasoning and visible output. Settings are frozen when a conversation starts.",
  "ai-support-output-budget-warning": "An output budget below 8000 tokens can cut off reasoning or the answer. Start with 16000 tokens.",
  "ai-support-verbosity-auto": "Auto",
  "ai-support-verbosity-concise": "Concise",
  "ai-support-verbosity-detailed": "Detailed",
  "ai-support-settings-warning-over-default":
    "{{field}} is above the recommended default (recommended: {{recommended}}, current: {{current}}).",
  "ai-support-triage-model-required": "Enter a triage model.",
  "ai-support-investigation-model-required":
    "Enter an investigation model.",
  "ai-support-reasoning-effort-required": "Choose a reasoning effort.",
  "ai-support-verbosity-required": "Choose a verbosity level.",
  "ai-support-max-tool-rounds-required":
    "Max tool rounds must be greater than zero.",
  "ai-support-max-input-tokens-required":
    "Max input tokens must be greater than zero.",
  "ai-support-max-output-tokens-required":
    "Max output tokens must be greater than zero.",
  "ai-support-timeout-minutes-required":
    "Timeout minutes must be greater than zero.",
  "ticket-signature": "Ticket signature",
  "time-logs": "Time logs",
  "ai-8x-recommended": "AI x{{multiplier}} suggested invoice: {{value}}",
  "ai-8x-recommended-total": "AI x{{multiplier}} suggested total",
  "ai-8x-recommended-short": "AI x{{multiplier}}",
  "ai-type": "AI / Codex",
  "total-time-tracked": "Total time tracked",
  "travel-details": "Travel details",
  "travel-start-date-time": "Travel start datetime",
  "travel-type": "Travel type",
  "travel-warrant": "Travel warrant",
  "travel-warrant-items": "Travel warrant expenses",
  "travel-warrants-overview": "Travel warrant overview",
  "writing-response-forward": "Forwarding response",
  "writing-response-new": "Writing new response to",
  "writing-response-note": "Writing a note",
  "writing-response-reply": "Writing a reply to",
  CLOSED: "Closed",
  OPEN: "Open",
  SENT_TO_PANTHEON: "Sent to pantheon",
  address: "Address",
  basic: "Basic",
  billable: "Billable",
  by: "By",
  codebooks: "Codebooks",
  codriver: "Co-driver",
  contacts: "Contacts",
  content: "Content",
  costTypeId: "Cost type",
  country: "Country",
  currency: "Currency",
  currencyId: "Currency",
  driver: "Driver",
  edit: "Edit",
  emails: "Emails",
  fullname: "Full name",
  general_tenant_settings: "General settings",
  header: "Header",
  isPrimary: "Primary",
  makeAndModel: "Make and model",
  notes: "Notes",
  place: "Place",
  registration: "Registration",
  report: "Report",
  search: "Search",
  transport: "Transport",
  travel_warrants: "Travel warrants",
  travel_warrants_settings: "Travel warrant settings",
  work_records_settings: "Work records settings",
  WorkRecords: "Work records",
  TravelWarrants: "Travel warrants",
  UserSynchronization: "User synchronization",
  BusinessAnalytics: "Analysis",
  DuplicateUserName: "Username already exists",
  InvalidUserName:
    "Enter a valid username without diacritics, you can use letters, numbers and characters -._@+",
  "The Password field is required.": "Password field is required",
  logout: "Logout",
  language: "Language",
  exit: "Exit",
  return_to_main_user: "Return to  main user",
  user_settings: "User settings",
  warning: "Warning",
  cancel: "Cancel",
  activate: "Activate",
  deactivate: "Deactivate",
  are_you_sure_you_want_to: "Are you sure you want to",
  user: "User",
  editing_work_hours: "Editing work hours",
  adding_work_hours: "Adding work hours",
  hours: "Hours",
  minutes: "Minutes",
  note: "Note",
  save: "Save",
  delete: "Delete",
  enter_valid_integer: "Enter a valid integer",
  editing_work_record: "Editing work record",
  adding_work_record: "Adding work record",
  today: "Today",
  cost_bearer: "Job number",
  cost_type: "Cost type",
  this_user_id_deactivated: "This user is deactivated",
  users: "Users",
  administration: "Administration",
  companies: "Companies",
  activity_reports: "Activity",
  workers: "Employees",
  settings: "Settings",
  work_records: "Work records",
  overview: "Overview",
  finalizing: "Finalizing",
  transfer: "Transfer",
  analysis: "Analysis",
  company: "Company",
  applications: "Applications",
  manual: "Instructions",
  end: "End",
  next: "Next",
  finish_manual: "Finish manual",
  while_manual_is_open_test_data_is_shown:
    "While the instructions are open, test data is displayed",
  tutorial_work_records_date_picker:
    "Select the year and period for which you want to see the data",
  tutorial_work_records_table:
    "Data for the selected period is displayed here, double-clicking on a row opens the edit form.",
  tutorial_work_records_add_row:
    "Clicking 'Add' opens the row input form. A row represents the period and has a job number and cost type.",
  tutorial_work_records_first_day:
    "Clicking on any cell in the row opens a form for adding or editing the number of hours worked on that day.",
  tutorial_user_top_bar:
    "In this drop-down menu you can log out or adjust your basic user settings",
  tutorial_manual_end:
    "By clicking 'Instructions' you can always restart the instructions for the page you are currently on.",
  tutorial_tenant_users:
    'As an administrator, you can view users of your business by clicking "Employees"',
  tutorial_work_records_overview:
    "Here you can see the work logs entered by job number, cost type and employee",
  tutorial_work_records_finalize:
    "Click on finalize to lock and unlock the period",
  tutorial_work_records_upload:
    'To transfer data to Pantheon, select "Transfer"',
  tutorial_work_records_application:
    'To add and edit work records, click "Work Records"',
  tutorial_company_settings:
    "Cost types and data synchronization (employees/job numbers) are under company settings",
  tutorial_company_settings_cost_types:
    "Here you can see the cost types that you and your employees can use when adding work records. \n The name of cost type will be displayed while adding work records. Only active cost types are displayed. \n You choose the cost type when editing, cost types are transferred from your Pantheon program. \n Double-clicking the row opens the edit form.",
  tutorial_work_records_tenant_data_sync:
    "Some data needs to be synchronized from your database to ours. This check is run periodically and should not be run manually. If you want to see the changes before the next automatic synchronization click on 'Start synchronization'. The data to be synchronized are users and cost types.",
  tutorial_work_records_overview_results:
    "The overview of the work records shows data views by holder, cost type and employee. You can filter the view by employee, cost type, job number, or period.",
  work_records_overview: "Work records overview",
  work_records_upload: "Work records transfer",
  tutorial_work_records_finalize_date:
    "Use this calendar to select a period to finalize",
  tutorial_work_records_finalize_users:
    "This will show users for whom a work record is available for the selected period. You can lock the data for the entire period by clicking 'Lock All'. Clicking on an employee will select them for locking. To unlock, click on employee again or 'Unlock All'.",
  tutorial_work_records_finalize_finalized:
    "This shows the workers whose data is locked for the selected period. Clicking on a worker changes the status of user data between locked and unlocked.",
  tutorial_work_records_upload_date:
    "Use the calendar to select the period whose data you want to transfer to your Pantheon system.",
  tutorial_work_records_upload_users:
    "Users who have data for the selected period are shown here.",
  tutorial_work_records_upload_already_uploaded:
    "If there are already uploads, you will see this message. Employees who already have data transferred cannot be selected for re-transfer.",
  tutorial_work_records_upload_checked_for_upload:
    "Click on a user to mark it for transfer or click on the 'Remaining Workers' transfer button. Only users who have submitted their data for finalizing can be selected.",
  tutorial_work_records_closed_period:
    "If the period is locked this message will be displayed. As an administrator, you can click on it to quickly unlock the period.",
  tutorial_as_admin_user_picker:
    "As an administrator, here you can select the user for whom you want to edit the data.",
  overview_by_cost_bearer: "Overview by job number",
  overview_by_cost_type: "Overview by cost type",
  overview_by_worker: "Overview by employee",
  homepage: "Homepage",
  tutorial_work_records_overview_by_cost_bearer:
    "This will show the results of your search, grouped by job number, cost type, and employee.",
  tutorial_work_records_overview_results_workers:
    "In the overview by cost type, you can see the total time spent by cost type.",
  tutorial_work_records_overview_workers:
    "You can see a detailed view of the records for each employee in the period by employee overview.",
  tutorial_work_records_overview_workers_edit:
    "Clicking on the icon next to the worker opens an application view of the work record in which you can edit the displayed data.",
  tutorial_work_records_overview_locked: "This is how locked periods are shown",
  tutorial_work_records_dashboard:
    'To add and edit work records, click "Work Records"',
  tutorial_work_records_closed_period_user:
    "If the period is locked this message will be displayed",
  manual_end: "End of Instructions",
  work_record_period_closed_and_cannot_be_changed:
    "This period is locked and cannot be changed",
  work_record_ready_to_finalize_and_cannot_be_changed:
    "This period has been marked as ready to finalize, to change the data use 'Not ready to finalize' button",
  do_you_want_to_unlock_work_record_period: "Do you want to unlock the period?",
  yes: "Yes",
  no: "No",
  finalizing_period: "Finalizing period",
  tutorial_work_records_send_to_finalize:
    "By clicking submit for finalizing, the period is temporarily locked and sent to the administrator on review before the final closing of the period. Only periods sent for finalizing can be finalized.",
  personal_data: "Personal data",
  download: "Download",
  contact_us_for_deleting_user_data: "Contact us to delete your account.",
  personal_data_download_text:
    "Your account contains the personal information you have provided us with. You can download or delete this information on this page.",
  personal_data_delete_text:
    "Deleting this information will also permanently delete your account. If you take this action, your account and data can no longer be recovered.",
  login_again_with_new_user_details: "Sign in with new user information",
  profile: "Profile",
  username: "Username",
  email: "E-mail",
  save_changes: "Save changes",
  you: "You",
  total: "Total",
  client: "Client",
  name: "Name",
  not_ready_to_finalize: "Not ready to finalize",
  send_to_finalize: "Send to finalize",
  login_or_using_app_in_period:
    "First login or use of the application in a period",
  send_again: "Resend",
  delete_report: "Delete report",
  are_you_sure_you_want_to_delete_report:
    "Are you sure you want to delete the report and all report items?",
  report_details: "Report details",
  active_users: "Active users",
  is_sent: "Sent",
  last_month: "Last month",
  next_month: "Next month",
  packets: "Packets",
  actions: "Actions",
  editing_settings: "Edit settings",
  companiesLowerCase: "companies",
  application_packets: "Application packets",
  adding_packet: "Adding a packet",
  sql_form: "SQL form",
  sql_response: "SQL response",
  run: "Run",
  run_on_all_databases: "Run on all databases",
  run_on_all_companies: "Run on all companies",
  sql_tab_default_name: "Script",
  sql_tab_add: "New script tab",
  sql_tab_close: "Close tab",
  sql_tab_rename_hint: "Rename tab (double-click)",
  sql_tab_rename_prompt: "Tab name",
  sql_tab_close_confirm: "Close this script tab? Its SQL text will be deleted.",
  run_on_all_companies_description:
    "Enabled: Run executes on all companies, and Run on all databases executes on all companies and all databases on their servers (skipping already executed server/database targets).",
  fix_and_run_query: "Correct and run the query",
  start_query: "Run the query",
  add: "Add",
  add_packet: "Add packet",
  company_does_not_have_any_packets:
    "The company has no active application packets",
  without_company: "No company",
  without_user: "No user",
  mimic: "Impersonate",
  editing_user: "Editing user",
  this_user_can_administer_everything: "This user can administer to our users",
  firstname: "First name",
  lastname: "Last name",
  user_roles: "User roles",
  pick: "Pick",
  for_pantheon_settings_pick_company:
    "Select a company to see the Pantheon settings",
  pantheon_user: "Pantheon user",
  pick_a_user: "Select a user",
  document_types: "Document types",
  default_document_type_is_required: "The default document type is required",
  default_document_type: "The default document type",
  take_from_user: "Take from user",
  CanChooseDocumentType: "Selecting a document Type",
  MakePDFOnFinalizingOrder: "Create a PDF from your order",
  WarnIfOrderItemQuantityMoreThanAvailable:
    "Warns if item quantity is greater than available",
  PrintOnFinalizingOrder: "Make an order print",
  ShowOnlyAvailableItemsInStockItemsView:
    "Only show available items in the warehouse overview",
  StockInitiallyShowAllAvailableOnStock:
    "Initially display all items in stock in the warehouse overview",
  InitiallyShowAllAvailableOnStock:
    "Initially display all items in storage in search",
  SquareTilesForArticlePicker: "Tiles when selecting an item",
  RestrictSearchToSmallerSet: "Limit search to 10 items",
  UseCachingForArticleSearch: "Uses cache",
  UseCachingForCustomerSearch: "Uses cache",
  RepeatLastArticleSearch: "Repeat previous item search",
  DetailedItemViewInDocument: "Detailed view of the list of items added",
  UseCachingForWorkOrders: "Uses cache",
  CacheDuration: "Duration (minutes)",
  BluetoothPrintCopiesNumber: "Number of copies to print",
  UseDarkTheme: "Uses a dark theme",
  OrderShouldMakeAReservation: "Make a reservation in stock from your order",
  CanEditOrderItemPrice: "Price change",
  DisalowOrderItemQuantityMoreThanAvailable:
    "The quantity of an item should not be greater than that available",
  UseSerialForItems: "Uses the serial number for the items",
  CanDeleteOrderItems: "Can delete order items",
  CanDeleteMoveItems: "Can delete shipping order items",
  warehouse: "Warehouse",
  article_search: "Article Search",
  customer_search: "Search recipient",
  viewing_selected_articles: "View selected items",
  work_orders: "Work orders",
  cache: "Cache",
  print: "Print",
  rest: "Other",
  internal: "Internal",
  documents: "Documents",
  confirm_download: "Confirm download",
  onix_phone_settings: "Onix Phone settings",
  last_reported_version: "Last reported version",
  ares_version_source_cached: "Cached value",
  ares_version_source_unavailable: "Check unavailable",
  ares_update_queued: "Ares update has been queued in the background.",
  ares_update_queued_all_databases:
    "Ares update has been queued in the background for this and linked databases.",
  ares_update_in_progress: "Ares update is in progress.",
  ares_update_in_progress_all_databases:
    "Ares update is in progress for this and linked databases.",
  ares_update_finished: "Ares update has finished.",
  ares_update_finished_all_databases:
    "Ares update has finished for this and linked databases.",
  ares_update_failed: "Ares update finished with an error.",
  ares_update_failed_all_databases:
    "Ares update finished with an error on this or a linked database.",
  ares_update_state_queued: "Queued",
  ares_update_state_running: "In progress",
  ares_update_state_finished: "Done",
  ares_update_state_failed: "Error",
  last_token_refresh: "Last token refresh",
  last_login: "Last login",
  onix_phone_details: "Onix Phone details",
  none: "None",
  pantheon_not_connected_cannot_change:
    "Pantheon not connected, editing disabled",
  pantheon_successfully_connected: "Pantheon successfully connected",
  adding_user: "Adding a user",
  loading: "Loading",
  password: "Password",
  add_a_user: "Add user",
  company_not_selected: "Company not selected",
  onix_phone: "Onix Phone",
  version: "Version",
  platform: "Platform",
  active: "Active",
  new_user: "New user",
  change_user: "Edit user",
  user_search: "User search",
  show_deactivated: "Show deactivated",
  loading_initial_user_settings: "Loading initial user settings",
  you_have_no_applications: "You have not access to applications",
  "The Email field is required.": "E-mail field is required.",
  "The Email field is not a valid e-mail address.":
    "Field must be a valid E-mail address.",
  "The Title field is required.": "Field Title is required.",
  "The Message field is required.": "Field Message is required.",
  username_or_email: "Username or e-mail",
  login: "Login",
  key: "Key",
  value: "Value",
  mimicking_user: "Impersonating user",
  mimicking_in_progress: "Impersonating user in progress",
  page_not_found: "Page not found",
  link: "The link",
  is_written_wrong_or_does_not_exist_anymore:
    "is written wrong or does not exist anymore",
  back: "Back",
  back_to_dashboard: "Back to homepage",
  not_possible_to_delete_cost_type:
    "It's not possible to delete cost type '{0}', work records exist that are using it. This cost type can be deactivated so it won't be used in the future.",
  company_settings: "Company settings",
  cost_types: "Cost types",
  cost_type_options: "Type of earning",
  you_have_no_cost_types: "You have no cost types",
  add_cost_type: "Add cost type",
  editing_cost_type: "Editing cost type",
  adding_cost_type: "Adding new cost type",
  code: "Code",
  active_cost_types_tooltip:
    "Active cost types can be used when adding work records",
  data_sync: "Data synchronization",
  sync_in_progress: "Synchronization in progress...",
  last_check: "Last check",
  last_sync: "Last synchronization",
  start_sync: "Start synchronization",
  user_not_active: "User not active",
  save_password: "Save password",
  administrator: "Administrator",
  name_and_surname: "Name and surname",
  company_users: "Company users",
  current_password: "Current password",
  new_password: "New password",
  repeat_password: "Repeat new password",
  change_password: "Save password",
  password_changed_successfully: "Password changed successfully.",
  total_hours: "Total hours",
  change_worker_cost_type_or_period:
    "Try changing employee, cost type or period",
  forceShowAvailableOnStock: "U pregledu prikaži dostupno",
  Inventory: "Inventura",
  WarehouseReceipt: "Primka",
  date: "Date",
  time: "Time",
  description: "Description",
  no_user: "Without user",
  from: "From",
  to: "To",
  all_dropdown: " - All - ",
  month_picker: "Month picker",
  reset_to_default: "Reset to default",
  by_cost_bearer: "By job number",
  by_cost_type: "By cost type",
  by_worker: "By employee",
  worker: "Employee",
  close: "Close",
  all_workers: "All employees",
  rest_of_workers: "Remaining employees",
  only_picked_workers: "Only selected employees",
  for_this_period_data_exists_in_pantheon:
    "There is already data in Pantheon for this period. Only the data of the remaining employees can be transferred.",
  start_data_upload: "Start data transfer",
  period: "Period",
  period_is_locked: "Period is finalized",
  unlock_all: "Unlock all",
  lock_all: "Lock all",
  no_items_for_selected_period: "No items for selected period",
  save_note: "Save note",
  year: "Year",
  month: "Month",
  on_date: "On date",
  "User not ready": "This user is not ready to work, contact us for help.",
  "User not found": "User not found.",
  "The UserNameOrEmail field is required.":
    "Username or E-mail field is required.",
  "Invalid password": "Incorrect password.",
  no_results: "No results",
  pick_month: "Pick a month",
  no_items: "No items",
  or: "Or",
  never: "Never",
  pick_date: "Pick a date",
  calendar: "Calendar",
  no_workers_for_selected_period: "No users with data for selected period",
  not_sent_to_finalize: "Not sent to finalize",
  "Polje trenutna lozinka je obavezno.": "Field current password is required.",
  "Polje nova lozinka je obavezno.": "Field new password is required.",
  "Nova lozinka i ponovljena lozinka se ne podudaraju.":
    "New password and repeated password are not the same.",
  "Nova lozinka mora imati barem 6 i najviše 100 znakova.":
    "New password must have at least 6 and at most 100 characters.",
  "Trenutna lozinka neispravna.": "Current password incorrect.",
  work_records_transfer_successful: "Transfer completed successfully",
  there_was_an_error: "An error occured",
  add_multiple_work_hours: "Add selected work hours",
  are_you_sure_you_want_to_delete_work_record:
    "Are you sure you want to delete the row and all related work hours with it?",
  details: "Details",
  untoggle_multiple_work_hours: "Unselect work hours",
  selected_days_for_work_hours: "Selected dates",
  adding_multiple_work_hours: "Adding multiple work hours",
  number_of_multiple_work_hours: "Selected work hours",
  exceeding_work_hours_for: "Days for which work hours would exceed 24 hours",
  support: "Support",
  "onix-clr-installations": "Onix CLR installations",
  "sql-backup-overview": "SQL backup overview",
  "add-onix-clr-installation": "Add Onix CLR installation",
  "edit-onix-clr-installation": "Edit Onix CLR installation",
  "last-reported-on": "Last reported",
  "add-company-machine-uid": "Add Company Machine UID",
  "edit-company-machine-uid": "Edit Company Machine UID",
  "link-by-database-and-machine": "Link by database and machine",
  "link-by-machine": "Link only by machine",
  "link-onix-clr-installations": "Link Onix CLR installations",
  "selected-onix-clr-installations-count": "Selected: {{count}}",
  "select-onix-clr-installations": "Select Onix CLR installations first.",
  "select-company-for-onix-clr-linking": "Select a company first.",
  "onix-clr-link-missing-machine-uid":
    "Selected rows are missing a machine UID: {{machineUids}}",
  "onix-clr-link-missing-database":
    "These machine UIDs need a database for database-specific linking: {{machineUids}}",
  "onix-clr-link-different-company-blocked":
    "These machine UIDs already have an exact mapping to another company. Update those mappings first: {{machineUids}}",
  "onix-clr-link-already-exists": "All selected installations are already linked.",
  "onix-clr-installations-pivot-installations": "Installations",
  "onix-clr-installations-pivot-mappings": "Company mapping",
  "onix-clr-installations-pivot-unmapped": "Unmapped machines",
  "onix-clr-installations-pivot-audit": "Usage audit",
  "show-only-unmapped-installations": "Show only unmapped machines (with recommendation)",
  "onix-clr-unmapped-machines-description":
    "Machines that still have no company mapping, with recommended company matches by database name.",
  "onix-clr-recommended-company": "Recommended company",
  "onix-clr-recommendation-score": "Score",
  "onix-clr-recommendation-reason": "Recommendation reason",
  "onix-clr-recommendation-exact-match": "Exact database/company match",
  "onix-clr-recommendation-database-contains-company":
    "Database name contains company name",
  "onix-clr-recommendation-company-contains-database":
    "Company name contains database name",
  "onix-clr-recommendation-shared-tokens": "Shared name tokens",
  "onix-clr-audit-non-public-not-allowed":
    "Non-public Ares usage that is not allowed",
  "onix-clr-audit-company-not-allowed":
    "Company databases that are not yet allowed for CLR",
  "onix-clr-audit-usage-without-mapping":
    "Databases using CLR report without DMS mapping",
  "onix-clr-audit-issue": "Issue",
  "onix-clr-not-allowed": "Not allowed",
  "onix-clr-issue-installation-not-allowed": "Installation is not allowed",
  "onix-clr-issue-company-not-mapped-to-group":
    "Company is not mapped to this non-public Ares group",
  "onix-clr-issue-installation-and-company-not-mapped":
    "Installation is not allowed and company is not mapped to this non-public Ares group",
  generated: "Generated",
  connect: "Link",
  server: "Server",
  database: "Database",
  instance: "Instance",
  edition: "Edition",
  machineUID: "Machine UID",
  allowed: "Allowed",
  "data-already-uploaded": "Data already transferred",
  "data-not-ready-to-finalize": "Data not marked as ready to finalize",
  "data-not-finalized": "Data not finalized",
  contact: "Contact",
  priority: "Priority",
  source: "Source",
  status: "Status",
  type: "Type",
  due_date: "Due date",
  Closed: "Closed",
  High: "High",
  Low: "Low",
  Medium: "Medium",
  Open: "Open",
  Pending: "Pending",
  Phone: "Phone",
  Resolved: "Resolved",
  Urgent: "Urgent",
  WaitingOnCustomer: "Waiting on customer",
  WaitingOnThirdParty: "Waiting on third party",
  "add-note": "Add note",
  "add-ticket": "Add ticket",
  agent: "Owner",
  "assigned-to": "Assigned to",
  dueToday: "Due today",
  forward: "Forward",
  mine: "Mine",
  "new-ticket": "New ticket",
  onHold: "On hold",
  open: "Open",
  overdue: "Overdue",
  reply: "Reply",
  "reported-by": "Reported by",
  "ticket-details": "Ticket details",
  "ticket-is-due": "This ticket is overdue",
  title: "Title",
  unresolved: "Unresolved",
  "save-filter": "Save filter",
  filter: "Filter",
  this_user_is_deactivated: "This user is not active",
  cost_group_options: "Cost group",
  "The PantheonCostGroup field is required.": "Pick a cost group",
  "The CostType field is required.": "Enter cost type name",
  "The PantheonCostType field is required.": "Pick an earning type",
  "enter-a-valid-time": "Enter a valid time",
  allowance: "Allowance",
  "total-per-diems": "Days for per diem",
  "has-backing-invoice": "R1 invoice",
  hasBackingInvoice: "R1 invoice",
  "send-to-pantheon": "Send to Pantheon",
  "travel-warrant-closed": "Travel warrant is closed",
  "travel-warrant-sent-to-pantheon": "Travel warrant is sent to Pantheon",
  travels: "Travel",
  "travel-type-short": "Travel",
  meter: "Meter",
  departure: "Departure",
  return: "Return",
  expenses: "Expenses",
  notForPayment: "Not for payment",
  "total-km": "Total KM",
  "adding-new-contact": "Adding new contact",
  "editing-contact": "Editing contact",
  "paging-of": "of",
  "paging-on-page": "on page",
  "paging-showing": "Showing",
  page: "Page",
  fullName: "Full name",
  webshop: "Web shop",
  "webshop-items": "Web shop - articles",
  "adding-web-shop-item": "Adding article",
  "editing-web-shop-item": "Editing articel",
  featured: "Featured",
  discounted: "Discounted",
  "featured-categories": "Featured",
  "adding-featured-category": "Adding featured category",
  "editing-featured-category": "Editing featured category",
  "To Pantheon": "To Pantheon",
  "From Pantheon": "From Pantheon",
  "confirm-changing-travel-warrant-status-to-closed":
    "Once closed travel warrant cannot be opened. We'll attempt to send the closed travel warrant to Pantheon immediately or when the next data synchronization occurs. Do you want to proceed?",
  "this-page-has-multiple-tutorials": "This page has multiple tutorials",
  "pick-tutorial-to-get-started": "Pick a tutorial to get started",
  travel_warrants_from_dashboard:
    "By clicking 'Travel warrants' you can start adding travel warrants",
  travel_warrants_tutorial_company_settings:
    "By clicking on 'Settings' you can modify your company settings and start synchronization from and to your Pantheon database.",
  travel_warrants_status_dropdown:
    "By clicking on 'Status' dropdown you can change the travel warrant status filter. Travel warrants with status 'Open' can be modified, those with status 'Closed' are being prepared for sending to Pantheon and those with status 'Sent to Pantheon' are already transferred to your Pantheon system.",
  tutorial_travel_warrant_worker:
    "As administrator, you can view travel warrants of all workers in your company",
  travel_warrants_search_component:
    "Here you can enter a term to search travel warrants",
  travel_warrants_table_status_explanation:
    "If status is 'Closed' and not red, travel warrant is still being prepared for sending, if it's 'Closed' and red there was an error when system tried to synchronize the travel warrant. By clicking on that travel warrant you can see more details.",
  travel_warrants_add_travel_warrant:
    "By clicking on 'Add' you can start adding a new travel warrant",
  new_travel_warrant_tab:
    "Content of tab 'Travel' shows the travel warrant header data.",
  tutorial_travel_warrant_pick_worker:
    "As administrator you can pick a worker for whom you are making the travel warrant",
  new_travel_warrant_pick_project:
    "Here you can pick the travel warrant project. If the project subject has the place and country those fields will be pre-filled for you.",
  "new-travel-warrant-general-transport":
    "Here you can enter transport type if it's not a company or personal vehicle",
  "new-travel-warrant-official-vehicle":
    "Here you can choose a company vehicle that we synchronized from your Pantheon system",
  "new-travel-warrant-personal-vehicle":
    "If you are using a personal vehicle you can pick it here",
  "new-travel-warrant-arrival-date":
    "Set the departure and arrival date and time so we can calculate your per diems",
  "new-travel-warrant-personal-vehicle-callout":
    "To add a new personal vehicle click here, follow the link 'Edit other personal vehicles' in the form that opens if you want to edit your existing vehicles",
  "new-travel-warrant-items-tab":
    "When you save the header details, travel warrant expenses tab will show",
  "new-travel-warrant-items-table":
    "Here you can see the travel expenses you added to travel warrant. ",
  "manual-is-active":
    "Tutorial is active, if there is a problem, click here to disable tutorial.",
  "travel-warrant-header-has-unsaved-changes":
    "This travel warrants header has unsaved changes, are you sure you want to leave this page?",
  "Personal vehicle does not belong to this user":
    "Vehicle does not belong to user",
  "Travel warrant country not set":
    "For the transfer, it is necessary to select the country on the travel warrant",
  "adding-new-company": "Adding new company",
  "editing-company": "Editing company",
  companyId: "Company",
  contactId: "Contact",
  "adding-new-email": "Adding email",
  "editing-email": "Editing email-a",
  "The ContactCompanyId field is required.": "Contact company is required",
  "no-tickets": "No tickets for current filter",
  "is-primary": "Primary",
  "The ContactEmailId field is required.": "Pick an Email",
  "The ContactId field is required.": "Pick a contact",
  "unread-messages": "Unread messages",
  BluetoothPrinterCharacterWidth: "Page width",
  travelEndDateTime: "Travel end",
  "travel-end-date-time": "Travel end",
  conversion: "Conversion rate",
  "The Conversion field is required.": "Conversion rate is required",
  "delete-travel-warrant": "delete travel warrant?",
  "expenses-total": "Total expenses",
  "down-payment": "Advance",
  "daily-allowance": "Per diem",
  quantity: "Quantity",
  "travel-warrant-is-sent-to-finalize":
    "This travel warrant has been marked as ready to finalize, to change the data use 'Not ready to finalize' button",
  "Travel warrant is sent to finalize":
    "This travel warrant has been marked as ready to finalize",
  SENT_TO_FINALIZE: "Sent to finalize",
  "travel-warrant-is-closed": "This travel warrant is closed",
  amount: "Amount",
  "cost-description": "Cost description",
  attachment: "Attachment",
  "picking-attachment": "Pick an attachment",
  "departure-place": "Place of departure",
  "enter-valid-date-range": "Enter a valid date range",
  send: "Send",
  "add-attachment": "Add attachment",
  "Pick a currency": "Pick a currency",
  "Enter a conversion rate": "Enter a conversion rate",
  "notify-email-or-agent": "Notify agent",
  "save-as-new-filter": "Save currenly active filter settings as a new filter",
  modifiedOn: "Modified",
  createdOn: "Created",
  dateDue: "Due date",
  "no-title": " - No title - ",
  "connect-to-contact": "Reassign E-mail addresses",
  "support-email-password": "Support E-mail password",
  "sql-error-547": "There is data related to this row and cannot be deleted",
  "unknown-sql-error": "Unknown SQL server error occured",
  "contact-and-company": "Contact and company",
  "status-and-agent": "Status and agent",
  Today: "Today",
  Yesterday: "Yesterday",
  ThisWeek: "This week",
  ThisMonth: "This month",
  LastMonth: "Last month",
  CustomRange: "Date range",
  "support-redirect-all-to-sender": "Redirect all outbound emails to sender",
  import: "Import",
  "saved-files-settings": "File saving settings",
  "temporary-agent": "Agent",
  agents: "Owner and agent",
  support_dashboard: "Overview",
  "status-and-priority": "Status and priority",
  "notify-of-unread-messages": "Send E-mail notifications for new messages",
  "do-you-want-to-delete": "Are you sure you want to delete {subject}?",
  "genitiv-message": "message",
  "writing-response-edit-note": "Editing a note",
  "save-note": "Save changes",
  "other-settings": "Other",
  upload: "Upload",
  croatian: "Croatian",
  english: "English",
  dashboard: "Home",
  "codebooks-companies": "Companies",
  "codebooks-contacts": "Contacts",
  "support-dashboard": "Support dashboard",
  "edit-ticket": "Ticket",
  "activity-reports": "Activity reports",
  "activity-records": "Activity report records",
  "work-records-overview": "Work records overview",
  "work-records": "Work records",
  finalize: "Finalizing",
  "travel-warrants": "Travel warrants",
  italian: "Italian",
  other: "Other",
  "open-tasks": "Tasks",
  "remove-ticket": "Remove ticket",
  "are-you-sure-you-want-to-delete-this-ticket":
    "Are you sure you want to remove this ticket? All it's time logs, messages and saved files/images will be deleted.",
  "not-assigned-ticket": "Unassigned ticket",
  "your-ticket": "Your ticket",
  "ticket-delegated-to-you": "Ticket delegated to you",
  "ticket-you-delegated": "Ticket you delegated",
  for: "For",
  "The AgentId field is required.": "Pick an agent",
  "Enter a positive timespan": "Enter the time",
  "no-title-warning": " - No title - ",
  project: "Projekt",
  "adding-new-project": "Adding a project",
  "codebooks-projects": "Projects",
  "editing-project": "Editing project",
  "no-projects-found": "No projects found, or there are no active projects",
  finished: "Finished",
  "no-agents-found": "No agents found",
  "are-you-sure-you-want-to-close-without-billable-time-log":
    "This ticket has no billable time logs, are you sure you want to continue?",
  "merge-ticket": "Merge ticket",
  "merge-ticket-from": "Merge all from ticket",
  "ticket-cannot-merge-into-itself": "A ticket cannot be merged into itself",
  "link-related-ticket": "Link related ticket",
  "link-branch": "Link branch",
  "related-branches": "Related branches",
  "branch-parents": "Branch parents",
  "branch-owner": "Owner: {{owner}}",
  "branch-temp-owner": "Temp: {{owner}}",
  "branch-depth": "Depth {{depth}}",
  "branch-updated": "Updated {{time}}",
  "branch-cycle-detected": "Branch #{{ticketId}} is already in this path.",
  "open-ticket": "Open ticket",
  linked: "Linked",
  "delete-company": "Delete company",
  "deleting-company": "Deleting company...",
  "delete-company-confirmation":
    "Delete company {{name}}? Deleting will fail if related records exist.",
  "merge-company": "Merge company",
  "merge-company-description":
    "Move everything from another company into this one.",
  "merge-company-search": "Search company to merge",
  "merge-company-suggestions": "Similar companies",
  "merge-company-confirm": "Merge into this company",
  "merge-company-conflicts-found":
    "Conflicts were found. Review each field before finishing the merge.",
  "merge-company-preview-description":
    "Choose how each field should be resolved before moving the source company into the target company.",
  "merge-company-fields": "Fields",
  "merge-company-related-items": "Related records",
  "merge-company-source": "Source",
  "merge-company-target": "Target",
  "merge-company-action": "Action",
  "merge-company-conflict": "Conflict",
  "merge-company-empty-value": "Empty",
  "merge-company-resolve-and-merge": "Resolve and merge",
  "merge-company-action-keep-target": "Keep target",
  "merge-company-action-take-source": "Take source",
  "merge-company-action-merge-both": "Merge both",
  "merge-company-outcome-will-move": "Will move",
  "merge-company-outcome-merge-existing": "Will merge with existing records",
  "merge-company-outcome-no-change": "No change",
  "merge-company-source-count": "Source: {{count}}",
  "merge-company-target-count": "Target: {{count}}",
  "merge-contact": "Merge contact",
  "merge-contact-description":
    "Move everything from another contact into this one.",
  "merge-contact-search": "Search contact to merge",
  "merge-contact-confirm": "Merge into this contact",
  choose: "Choose",
  clear: "Clear",
  program: "Program",
  tickets: "Tickets",
  "support-woocommerce-settings": "WooCommerce settings",
  secret: "Secret",
  location: "Location",
  AGENTS: "AGENTS",
  "ccemail-not-finished-do-you-want-to-continue":
    "You have an unfinished CC e-mail, do you want to continue?",
  "attachment-mentioned-but-does-not-exist":
    "Message content mentions an attachment, but no attachments were added, do you want to continue without them?",
  todo: "To do",
  "no-todos": "No To-dos",
  "add-todo-button": "Add to do",
  "mention-agents": "agents",
  culture: "Culture",
  timezone: "Time zone",
  "there-are-some-updates-a-refresh-is-required":
    "Softver has been updated, to apply changes refresh the page",
  refresh: "Refresh",
  "time-format": "Date and time format",
  support_todos: "To do",
  "support-todos": "To dos",
  "adding-support-todo": "Adding a to do",
  "editing-support-todo": "Editing a to do",
  "ticket-title": "Ticket title",
  dateTime: "Date",
  ticketId: "Ticket",
  synced: "Synchronized",
  "synchronize-timelogs": "Synchronize time logs",
  "document-number": "Document number",
  "total-costs": "Total",
  "Travel warrant expense bearer not set": "Set expense bearer",
  "Travel warrant place not set": "Place not set",
  "Travel warrant start date and time not set": "Set start date and time",
  "Travel warrant end date and time not set": "Set end date and time",
  "created-time-log-on-date": "Time log date",
  "time-log-sync": "Time logs synchronization",
  "time-log-exported": "Exported",
  "time-log-exported-on": "Exported {{date}}",
  "time-log-not-exported": "Not exported",
  "last-month": "Last month",
  "current-month": "Current month",
  nextWeek: "Next week",
  lastWeek: "Last week",
  lastDay: "Yesterday",
  nextDay: "Tomorrow",
  last: "Last",
  "responsible-agent": "Responsible agent",
  "reset-all": "Reset all",
  "are-you-sure": "Are you sure?",
  "reset-ticket-data": "reset ticket data?",
  "want-to-delete-message": "delete message?",
  "want-to-regenerate-message": "regenerate message with new signature?",
  "want-to-close-without-billable-time-log":
    "close ticket without any billable time?",
  "want-to-continue-without-attachment": "continue without an attachment?",
  "send-later": "Later",
  "send-later-title": "Outside work hours: send at the start of the next work hours ({{time}})",
  "scheduled-send": "scheduled send: {{time}} (the customer cannot see it yet)",
  "send-now": "Send now",
  "send-scheduled-now-confirm": "send the message now?",
  "want-to-merge-contact-with-contact":
    "merge: {emails} to contact {contact}. All tickets and companies will be merged to the new contact.",
  "want-to-continue-to-delete-without-where-query":
    "continue with DELETE method even without WHERE condition?",
  want_to_delete_report: "delete report and all it's items?",
  support_tasks: "Tasks",
  "support-tasks": "Tasks",
  "task-title": "Task message",
  customers: "Customers",
  databases: "Databases",
  support_time_logs: "Time logs",
  "canned-responses": "Canned responses",
  "canned-response-add": "Add canned response",
  "canned-response-edit": "Edit canned response",
  "canned-response-title": "Title",
  "canned-response-content": "Content",
  "insert-canned-response": "Insert canned response",
  "manage-canned-responses": "Manage canned responses",
  onixPhoneCompaniesOverview: "OnixPhone companies",
  supportCompany: "Support company",
  activeUsers: "Active users",
  showOnlyWithoutSupportCompany: "Only without linked support company",
  noSupportCompany: "No linked support company",
  companiesCount: "Companies: {{count}}",
  activeUsersCount: "Active users: {{count}}",
  selectOnixPhoneCompany: "Link to OnixPhone company",
  linkOnixPhoneCompany: "Link",
  onixPhoneExternalId: "ExternalId for OnixPhone",
  currentLinkedOnixPhoneCompany: "Currently linked OnixPhone company",
  previous: "Previous",
  "next-one": "Next",
  "The UserId field is required.": "Odaberite radnika",
  "The ItemId field is required.": "Odaberite artikl",
  "marservis-work-orders": "Work orders",
  "codebooks-customers": "Customers",
  "adding-customer": "Adding a customer",
  "editing-customer": "Editing a customer",
  subject: "Subject",
  subjectId: "Subject",
  "work-order-items": "Work order items",
  "adding-work-order": "Adding a work order",
  "editing-work-order": "Editing a work order",
  projectId: "Project",
  "adding-work-order-item": "Adding a work order item",
  "editing-work-order-item": "Editing a work order item",
  "adding-work-order-item-work": "Adding work order item work",
  "editing-work-order-item-work": "Editing work order item work",
  "work-order-item-work": "Work order item work",
  cause: "Cause",
  remedy: "Remedy",
  connectionSettings: "Connection settings",
  myEInvoiceSettings: "My e-invoce",
  "Travel warrant sent to pantheon":
    "Travel warrant is already sent to Pantheon",
  projects: "Projects",
  countryId: "Country",
  contactName: "Contact name",
  mail: "E-mail",
  longName: "Long name",
  phone: "Phone",
  vatidPrefix: "VAT ID prefix",
  vatid: "VAT ID",
  shortName: "Name",
  "done-hours": "Work hours",
  "not-finished": "Not finished",
  travel_to: "Travel to",
  workOrderWorkerPickerIncludesInactiveWorkers:
    "Show inactive workers in work order worker picker",
  showInventoryNumberOnWorkOrders: "Show inventory number on work orders",
  "company-notes": "Company notes",
  "comma-separated-tags": "Comma-separated tags",
  "this-is-not-our-customer": "Not our customer",
  OldTickets: "Very old tickets",
  HighPriorityTickets: "High priority tickets",
  "high-priority": "HIGH",
  "old-tickets-short": "OLD",
  "last-activity": "Last activity",
  onixPhone: "OnixPhone",
  onixPhoneCompany: "OnixPhone company",
  externalId: "External ID",
  userCount: "User count",
  usernames: "Usernames",
  activityCheckSql: "Activity check SQL",
  "new-messages-available": "New messages available",
  "viewing-now": "Viewing now",
  "ares-activity": "Ares activity",
  "ares-activity-last-check": "Last activity check",
  "ares-activity-result": "Activity result",
  aresActivityReport: "Ares activity report",
  onixClrUsageReport: "Onix CLR usage report",
  onixDmsBillingReport: "Onix DMS billing report",
  onixPhoneFunctionalityActivityReport: "OnixPhone functionality activity report",
  byCompanyAndUser: "By company and user",
  totalActivity: "Total activity",
  companyGroup: "Company",
  accountingCompanyGroup: "Accounting company",
  userGroup: "User",
  aresDeploymentGroup: "Ares group",
  "Select Ares implementation.": "Select Ares implementation.",
  "Select database.": "Select database.",
  "Select Ares group.": "Select Ares group.",
  "Ares group installed for {{companyName}}.":
    "Ares group installed for {{companyName}}.",
  "Create companies": "Create companies",
  "Create companies ({{count}})": "Create companies ({{count}})",
  "Companies were created!": "Companies were created!",
  "Install selected Ares group": "Install selected Ares group",
  "Install selected Ares group for new company":
    "Install selected Ares group for new company",
  "New Ares group for new company": "New Ares group for new company",
  "Install Ares group": "Install Ares group",
  "Installing Ares group...": "Installing Ares group...",
  "Ares implementations": "Ares implementations",
  "Ares versions": "Ares versions",
  "Loading versions...": "Loading versions...",
  "Installation steps": "Installation steps",
  "On all databases": "On all databases",
  "Update all Areses": "Update all Areses",
  "Search by database or company": "Search by database or company",
  "Search Ares group": "Search Ares group",
  Environment: "Environment",
  deselect: "Unselect all",
  "Select all": "Select all",
  "No payload provided.": "No payload provided.",
  "Database name is required.": "Database name is required.",
  "Accounting company not found.": "Accounting company not found.",
  "Accounting company Pantheon connection string is empty.":
    "Accounting company Pantheon connection string is empty.",
  "Selected Ares group does not belong to this accounting company.":
    "Selected Ares group does not belong to this accounting company.",
  "Ares group not found.": "Ares group not found.",
  "Ares group is required.": "Ares group is required.",
  "Ares service is not configured.": "Ares service is not configured.",
  "Ares installation is already in progress for this company.":
    "Ares installation is already in progress for this company.",
  "No companies found for the given accounting company.":
    "No companies found for the given accounting company.",
  firstSeen: "First seen",
  lastSeen: "Last seen",
  accountingCompany: "Accounting company",
  zbirno: "Zbirno",
  zbirnoRacunovodstvo: "Zbirno accounting",
  onixPhoneDmsUsage: "OnixPhone DMS usage",
  dmsPantheonUsage: "DMS Pantheon usage",
  pantheonDocumentCount: "Pantheon document count",
  databaseCount: "Database count",
  sourceIssues: "Source issues",
  message: "Message",
  generatedOn: "Generated on",
  linkedCompanySettingsId: "Linked company settings",
  accountingUserId: "Accounting user",
  activityCheckSqlHelpTitle: "How activity check works",
  activityCheckSqlHelp:
    "Run against each company's Pantheon DB. Return 1 row, 1 column; >0/true/non-empty => active; 0/false/empty/no rows => inactive.",
  exportToCSV: "Export to CSV",
  exportToExcel: "Export to Excel",
  connection: "Connection",
  documentType: "Document type",
  sourceTable: "Source table",
  counter: "Counter",
  action: "Action",
  summary: "Summary",
  count: "Count",
  records: "records",
  executionPhase: "Execution phase",
  executionPhaseOrder: "Phase order",
  Standard: "Standard",
  Bootstrap: "Bootstrap",
  SqlExecution: "SQL execution",
  TestRefreshSetup: "Test refresh setup",
  TestSuite: "Test suite",
  TestTeardown: "Test teardown",
  "unit-of-measure": "Unit of measure",
  "adding-marservis-material": "Add material",
  "editing-marservis-material": "Edit material",
  "add-material": "Add material",
  "material-can-be-selected-once": "A material can only be selected once.",
  "quantity-must-be-positive": "Quantity must be greater than zero.",
  "onix_web_app": "Onix Web",
  "portal_tickets_tile": "Support tickets",
  "portal_sign_in_title": "Customer sign-in",
  "portal_sign_in_intro": "Follow your Onix support tickets. Enter the email address you write to support from and we will send you a sign-in code.",
  "portal_sign_in_open": "Customer sign-in (tickets)",
  "portal_email": "Email",
  "portal_email_invalid": "Enter a valid email address.",
  "portal_send_code": "Send code",
  "portal_code": "Code from the email",
  "portal_code_sent": "If the address is valid, we sent a six-digit code to {{email}}. It is valid for 10 minutes.",
  "portal_verify_code": "Sign in",
  "portal_other_email": "Use another address",
  "portal_consent_title": "New customer account",
  "portal_consent_intro": "There is no account for {{email}} yet. The account only lets you follow your Onix support tickets, and you can delete it in your profile.",
  "portal_consent_checkbox": "I agree to opening an account and to the processing of my email address and name to show my tickets.",
  "portal_create_account": "Create account",
  "portal_sign_in_failed": "Sign-in failed.",
  "team-viewer-script-token": "TeamViewer script token",
  "team-viewer-script-token-description": "Token from your TeamViewer profile (Apps). Needs read access to connection reports, groups and devices. It does not expire, so it is never refreshed.",
  "team-viewer-script-token-saved": "TeamViewer token saved.",
  "team-viewer-script-token-failed": "Saving the TeamViewer token failed.",
};
